var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconContactInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 64,
    height: 64,
    rx: 8,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4509 26.276C30.5989 26.414 29.7807 26.7387 29.1604 27.3275C28.2754 28.1682 27.9109 29.4372 27.8779 30.6575C27.8442 31.898 28.1442 33.1985 28.9707 34.124C30.1047 35.3937 32.0794 35.705 33.6739 35.1095C36.4774 34.0617 38.9112 30.1197 36.3597 27.6027C35.3329 26.5895 33.8299 26.1717 32.3877 26.1942C32.0764 26.1995 31.7614 26.2257 31.4509 26.276Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9273 41.4613C40.6766 42.0635 41.0591 42.9515 41.4978 43.8508C42.1271 45.1415 42.7076 46.511 42.6311 47.978C42.6018 48.542 42.4676 49.1195 42.1226 49.5665C41.5548 50.3022 40.5626 50.5317 39.6513 50.7132C35.6231 51.5135 31.5633 52.3122 27.4563 52.3235C25.9286 52.328 24.3641 52.214 22.9661 51.5982C22.2731 51.293 21.5853 50.8055 21.3798 50.0765C21.2013 49.442 21.4256 48.77 21.6581 48.1527C22.2543 46.5732 22.9226 45.0215 23.6613 43.5035C23.8361 43.1443 24.0213 42.7783 24.3183 42.512C24.5906 42.2683 24.9378 42.1265 25.2798 41.9983C28.8993 40.6415 32.8383 40.2688 36.6941 40.5373C37.5671 40.598 38.4551 40.6955 39.2546 41.0525C39.5096 41.165 39.7316 41.303 39.9273 41.4613Z",
    fill: "#FA532E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8249 26.2138C29.5166 26.336 29.2286 26.5003 28.9931 26.7305C28.5424 27.1708 28.3369 27.8 28.1854 28.4113C27.9056 29.5378 27.7564 30.7115 27.9049 31.8628C28.0534 33.014 28.5199 34.1465 29.3411 34.967C30.0754 35.7005 31.0556 36.152 32.0681 36.3808C32.9179 36.5728 33.8284 36.6125 34.6436 36.3043C37.3624 35.2753 39.1046 30.4145 37.4599 27.9748C36.9386 27.2008 36.1106 26.6788 35.2429 26.3353C33.7264 25.7345 32.0209 25.6228 30.4391 26.0203C30.2314 26.072 30.0236 26.1343 29.8249 26.2138Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3313 11.954C42.1368 12.1018 42.8996 12.3725 43.5416 12.8765C45.3543 14.2993 45.4893 16.9468 45.4713 19.2508C45.4293 24.5563 45.4016 29.8633 45.5261 35.1673C45.6011 38.3833 45.7308 41.612 45.4001 44.819C45.1263 47.4718 44.6546 50.5805 41.8173 51.6455C40.4876 52.145 39.0303 52.148 37.6098 52.1443C33.6693 52.1353 29.7288 52.1263 25.7883 52.1173C23.9126 52.1128 21.7526 51.9748 20.6261 50.474C19.9916 49.6295 19.8408 48.527 19.7298 47.4763C18.6498 37.2913 19.3338 27.0103 20.0186 16.7908C20.1048 15.5045 20.2466 14.0923 21.1728 13.1953C22.0773 12.32 23.4528 12.206 24.7098 12.1423C29.4813 11.9008 34.2581 11.6803 39.0356 11.7695C39.7953 11.7845 40.5821 11.816 41.3313 11.954Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8851 12.0507C25.8851 12.0507 25.8259 16.949 28.3046 17.303C30.7834 17.657 36.2126 17.303 37.0984 16.949C37.9834 16.595 38.9869 14.4702 38.6329 11.8145",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7444 51.1662C21.7444 51.1662 24.2284 41.7252 27.2839 40.9317C30.3394 40.1292 37.8341 39.7797 39.4301 41.4185C40.8986 42.9207 43.1179 49.4847 43.4674 50.5347",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactInfo);
export default __webpack_public_path__ + "static/media/icon-contact-info.d8a928db1fb5a4539904d72610145afd.svg";
export { ForwardRef as ReactComponent };